<div class="sub-heading mt-0" tabindex="0">
  {{providefeedback}}
</div>
<div class="mx-2-5 mb-3-5">
  <div class="my-1 right-panel-label-color">
    {{provideFeedbacksubtext}}
  </div>
    <app-location-breadcrumb></app-location-breadcrumb>
</div>

<div class="mx-2-5 mb-3-5">
  <div [formGroup]="feedBackForm">
    <mat-error class="mat-form-field" style="font-size: 1rem;" *ngIf="feedBackForm.controls.emailMismatch.errors != null && userRole == 'Basic'"> {{emailMismatchError}}</mat-error>
    <br />
    <mat-form-field class="width-100" *ngIf="userRole == 'Basic'">
      <mat-label class="textBox-text">{{emailLabel}}</mat-label>
      <input matInput maxlength="100" appAutoFocus class="textBox-text" type="text" formControlName="feedBackEmail" (keyup.enter)="enterKey()" />
      <mat-error class="mat-form-field mt_1" style="font-size: 1rem;" *ngIf="feedBackForm.controls.feedBackEmail.errors != null"> {{emailError}}</mat-error>
    </mat-form-field>

    <mat-form-field class="width-100 mt-2" *ngIf="userRole == 'Basic'">
      <mat-label class="textBox-text">{{emailConfirmationLabel}}</mat-label>
      <input matInput maxlength="100" class="textBox-text" type="text" formControlName="feedBackEmailVerify" (keyup.enter)="enterKey()" />
      <mat-error class="mat-form-field mt_1" style="font-size: 1rem;" *ngIf="feedBackForm.controls.feedBackEmailVerify.errors != null"> {{verifiedEmailError}}</mat-error>
    </mat-form-field>

    <mat-form-field class="width-100 mt-2" appHostListenerClick>
      <mat-label>{{typeoffeedback}}</mat-label>
      <mat-select #feedBackTypeSelect autofocusdropdown="true" placeholder="Select Feedback Type" formControlName="feedBackType">
        <mat-option class="bgc-blue" *ngFor="let type of feedbackTypeList" [value]="type.order">{{type.value}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-error class="mat-field-hint my-0-25 " style="font-size: 1rem;" *ngIf="feedbackTypeValidationError != ''"> {{feedbackTypeValidationError}}</mat-error>

    <mat-form-field class="width-100 mt-2">
      <mat-label class="textBox-text">{{yourfeedback}}</mat-label>
      <div class="textarea-wrapper flex-display">
        <textarea class="textBox-text textarea-padding" type="text" matInput cdkTextareaAutosize
                  cdkAutosizeMinRows="1"
                  cdkAutosizeMaxRows="6" (input)="annotationDescriptionChange($event.target.value)" formControlName="feedBackContent" maxlength="4000"></textarea>
        <div class="remaning">{{remainingText}}/4000</div>
      </div>
    </mat-form-field>

    <mat-error class="mat-field-hint my-0-25 " style="font-size: 1rem;" *ngIf="feedbackvalidationError != ''"> {{feedbackvalidationError}}</mat-error>
  </div>

  <div class="flex-display pt-1">
    <button mat-button class="btn-secondary-action-close" (click)="closeOverlay()" (keyup.enter)="closeOverlay()" tabindex="0">{{globalcancel}}</button> 
    <button mat-button class="btn-primary-action-add" (click)="submittFeedback()" (keyup.enter)="submittFeedback()" tabindex="0">{{globalsubmit}}</button>
  </div>


</div>

<div class="mx-2-5 mb-3-5">
  <div class="generalFeedbackText">
    {{generalFeedbacktext}}
  </div>
  <div class="highlight-blue cursor-pointer feedback-view-margin" (click)="addGeneralFeedback()" (keyup.enter)="addGeneralFeedback()" tabindex="0">
    <img src="../../../assets/icons/GeneralFeedback(General).svg" class="icon-image-para-action-feedback" alt="General Feedback">  &nbsp; <span class="underline feedback-view">{{generalFeedbacklink}}</span>
  </div>
</div>
